import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Lesson from './components/lesson';
import LessonsListSidebar from './components/lessons-list-sidebar';
import { loadPreviousLessonToWatch, loadSpecificLessonToWatch } from './redux/actions';
import { getWatchLessonState } from '../../selectors';
import { Loader } from '../../../components';
import UrlTo from '../../../url-to';
import { t } from '../../../i18n';
import Alert from 'react-bootstrap/Alert';
import BackButton from './components/back-button';
import PreviousAndNextLessonsFooter from './components/previous-and-next-lessons-footer';
import { postLessonWatchTime } from '../../../backend-api';
import LineLoader from '../../components/line-loader';
import HideIntercom from '../../../components/hide-intercom';
import './styles.scss';

const WatchLesson = ({ match, location }) => {
  const courseId = match.params.courseId;
  const [showSidebarForMobile, setShowSidebarForMobile] = useState(false);
  const { lesson, lessonsOverview, isLoading, hasError } = useSelector(getWatchLessonState);
  const lessonNumber = useMemo(() => new URLSearchParams(location.search).get('lesson'), [location]);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(!lessonNumber ? loadPreviousLessonToWatch(courseId) : loadSpecificLessonToWatch(courseId, lessonNumber));
  }, [courseId, lessonNumber]);

  const lessons = useMemo(
    () =>
      lessonsOverview &&
      lessonsOverview.map(l => ({
        ...l,
        isCurrent: l.lessonNumber === lesson.lessonNumber,
        watchUrl: UrlTo.coursesWatchLesson(courseId, l.lessonNumber),
      })),
    [lessonsOverview],
  );

  const handlePlaybackPositionChange = async watchTimeMilliseconds => {
    try {
      await postLessonWatchTime(courseId, lesson.lessonNumber, watchTimeMilliseconds);
    } catch (ex) {
      console.error('Unable to save lesson watch time.');
    }
  };

  if (hasError) {
    return <Alert variant="danger">{t('SERVER_ERROR')}</Alert>;
  }

  if (!lessons) {
    return (
      <div className="courses-watch-lesson courses-watch-lesson__loading-indication-wrapper">
        <LineLoader hide={!isLoading} className="courses-watch-lesson__line-loader" />
        <Loader />
      </div>
    );
  }

  return (
    <div className="courses-watch-lesson">
      <HideIntercom />
      <LessonsListSidebar
        lessons={lessons}
        showForMobile={showSidebarForMobile}
        onHideForMobile={() => setShowSidebarForMobile(false)}
      />
      <div className="courses-watch-lesson__content">
        <div className="courses-watch-lesson__content-back-header">
          <LineLoader hide={!isLoading} className="courses-watch-lesson__line-loader" />
          <BackButton to={UrlTo.coursesSpecificCourse(courseId)} />
        </div>
        {!!lesson && (
          <>
            <Lesson
              lesson={lesson}
              onToggleSidebar={() => setShowSidebarForMobile(true)}
              onVideoPlaybackPositionChange={handlePlaybackPositionChange}
            />
            {lessons.length > 1 && (
              <PreviousAndNextLessonsFooter
                previousLesson={lessons[lesson.lessonNumber - 1 - 1]}
                nextLesson={lessons[lesson.lessonNumber - 1 + 1]}
              />
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default WatchLesson;
